<template>
  <div class="popTable">
    <!-- <div class="tit">
      健康记录
    </div> -->
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      border
      header-align="center"
      :header-cell-style="{
        background: '#E0EAFB',
        color: 'rgba(0, 0, 0, 0.90)'
      }"
    >
      <el-table-column
        prop="create_at"
        label="创建时间"
        align="center"
        width="120"
        show-overflow-tooltip

      >
      </el-table-column>
      <el-table-column
        prop="recordTit"
        label="观察内容"
        align="center"
        width="140"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="place"
        label="观察地点"
        align="center"
        width="100"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="tname"
        label="维度"
        width="180"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="recordContent"
        label="内容"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      background
      :page-size="4"
      layout="prev, pager, next"
      :total="total"
      class="pagination"
    >
    </el-pagination>
    <div style="width: 100%;display: flex;justify-content: center;">
      <div
        style="cursor: pointer; box-sizing: border-box;padding: 10px 30px;background-color: #3681FC;color: #fff;border-radius: 10px;"
        @click.stop="closeTab"
      >
        关闭
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userid: {
      type: String
    },
    year: {
      type: String
    },
    tid: {
      type: String
    }
  },
  data() {
    return {
      //   txt: "c0f39c82-b34b-11ee-b534-005056b86db5",
      // 表格数据
      tableData: [],
      // 总条数
      total: 0,
      // 当前页
      page: 1
    };
  },
  methods: {
    closeTab() {
      this.$emit("handleClose");
    },
    // 获取数据
    getDataTab() {
      let params = {
        uid: this.userid,
        year: this.year,
        txt: this.tid,
        page: this.page
      };
      console.log('获取数据params',params);
      this.ajax
        .get(this.$store.state.api + "selectHealthRecord", params)
        .then(res => {
          console.log("获取关键证据数据popTable", res);
          this.total = res.data[0].length > 0 ? res.data[0][0].num : 0;

          this.tableData = res.data[0];
          // this.total = res.data[1][0].total;
        }); //
    },
    // 切换页
    handleCurrentChange(val) {
      //当页数发生改变的时候调用获取列表数据请求
      // console.log(`当前页: ${val}`);
      this.page = val;
      this.getDataTab();
    }
  },
  mounted() {
    this.getDataTab();
  }
};
</script>

<style scoped>
.popTable {
  background-color: #fff;
  width: 100%;
  /* position: absolute; */
  box-sizing: border-box;
  padding: 15px;
  /* top: 50%; */
  /* left: 50%; */
  /* transform: translate(-50%, -50%); */
  /* box-shadow: 0 0 10px #ccc; */
}
/* 深度修改 */


.tit {
  width: 100%;
  text-align: center;
  margin: 20px 0;
  color: rgba(0, 0, 0, 0.9);
  text-align: center;
  font-family: "Microsoft YaHei";
  font-size: 20px;
  font-style: normal;
  font-weight: bold;
  line-height: 22px; /* 137.5% */
}
.dialog_diy {
  box-sizing: border-box;
  /* padding: 0 10px 10px 10px; */
}
.dialog_diy >>> .el-dialog {
  /* height: 100%; */
  margin: 10vh auto !important;
}

.dialog_diy >>> .el-dialog__header {
  background: #454545 !important;
  padding: 15px 20px;
}

.dialog_diy >>> .el-dialog__body {
  height: calc(100% - 124px);
  box-sizing: border-box;
  /* padding: 0px; */
}

.dialog_diy >>> .el-dialog__title {
  color: #fff;
}

.dialog_diy >>> .el-dialog__headerbtn {
  top: 19px;
}

.dialog_diy >>> .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

.dialog_diy >>> .el-dialog__headerbtn .el-dialog__close:hover {
  color: #fff;
}

.dialog_diy >>> .el-dialog__body,
.dialog_diy >>> .el-dialog__footer {
  background: #fafafa;
}
.pagination {
  display: flex;
  justify-content: flex-end;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/kindStudentEva/test/component/popTable.vue